
import React, { useState } from 'react'
import { toast } from 'react-toastify';
import Select from 'react-select';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
const Export = () => {
    const [rows, setRows] = useState([
        {
            TAN_No: '',
            SectionCode: '',
            CertificateNo: '',
            Rate: '',

            ExemptionLimit: '',
            ValidForm: '',

            default: false,
        },
    ]);
    // Function to add a new row
    const CurrOpt = [{ value: 'Bags', label: 'Bags' },
    { value: 'Bulk', label: 'Bulk' },
    { value: 'Boxes', label: 'Boxes' },];
    const addRow = async () => {
        const currentRow = rows[rows.length - 1];

        // Check if the current row exists and if all its fields are filled
        if (currentRow && Object.values(currentRow).every(field => field !== '')) {
            // If all fields are filled, add a new row with empty fields
            setRows([...rows, {
                TAN_No: '',
                SectionCode: '',
                CertificateNo: '',
                Rate: '',

                ExemptionLimit: '',
                ValidForm: '',

                default: false,
            }]);
        } else {
            // Show an error message if any field is empty
            toast.error('Please fill all fields before adding a new row.');
        }
    };

    // Function to remove a row
    const removeRow = (index) => {
        if (rows.length > 1) {
            const updatedRows = rows.filter((_, i) => i !== index);
            setRows(updatedRows);
            // formik.setFieldValue('rows', updatedRows);
        } else {
            alert('At least one row must remain.');
        }
    };

    // Handle input change in each row
    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedRows = [...rows];
        updatedRows[index][name] = value;
        setRows(updatedRows);
        // formik.setFieldValue(`rows[${index}].${name}`, value);
    };
    return (
        <div>

            <div className="row">
                <div className="col-md-3">
                    <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                            Tot FOB Val (INR)<span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className='w-100'>
                            <input
                                type="text"
                                className="form-control form-control-sm w-100"
                                id="name"
                                name="name"
                                placeholder='Enter Name'
                            />
                        </div>
                    </div>
                </div>


                <div className="col-md-3">
                    <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                            Tot FOB Val (INR)
                        </label>
                        <div className='w-100'>
                            <input
                                type="text"
                                className="form-control form-control-sm w-100"
                                id="name"
                                name="name"
                                placeholder='Enter Name'
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                            Op. FOB Val (INR)
                        </label>
                        <div className='w-100'>
                            <input
                                type="text"
                                className="form-control form-control-sm w-100"
                                id="name"
                                name="name"
                                placeholder='Enter Name'
                            />
                        </div>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="mb-2 ">
                        <label htmlFor="name" className="form-label ">
                            Op. FOB Val (FC)
                        </label>
                        <div className='w-100'>
                            <input
                                type="text"
                                className="form-control form-control-sm w-100"
                                id="name"
                                name="name"
                                placeholder='Enter Name'
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-start justify-content-between flex-wrap row-gap-2 mb-4">

                <div className="d-grid align-items-center flex-wrap row-gap-2">

                    <div className="mb-2 form-check">
                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                        <label className="form-label" htmlFor="exampleCheck1">
                            Single FOB value
                        </label>
                    </div>
                </div>

            </div>
            <div className="table-responsive ">
                {/* <Table className="table datanew dataTable no-footer" pagination={false}
            dataSource={dataSource} columns={columns} /> */}
                <table className="table table-responsive border custom-table-th">
                    <thead>
                        <tr>
                            <th scope="col" className='bg-none'>Action</th>
                            <th scope="col" className='bg-none w-min-120'>Sr No</th>
                            <th scope="col" className='bg-none w-min-120'>Description</th>
                            <th scope="col" className='bg-none w-min-120'>FOB Value (INR)</th>
                            <th scope="col" className='bg-none w-min-120'>FOB Value (FC)	</th>
                            <th scope="col" className='bg-none w-min-120'>Quantity</th>
                            <th scope="col" className='bg-none w-min-120'>Unit	</th>
                            <th scope="col" className='bg-none w-min-120'>Op. Bal. (INR)</th>
                            <th scope="col" className='bg-none w-min-120'>Op. Bal. (FC)</th>
                            <th scope="col" className='bg-none w-min-120'>Op. Bal. Qty</th>
                            <th scope="col" className='bg-none w-min-120'>Unit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <div className="d-flex">
                                        <div className="add-icon cursor-pointer" onClick={addRow}>
                                            <AddIcon />
                                        </div>
                                        {index > 0 && (
                                            <div className="remove-icon cursor-pointer" onClick={() => removeRow(index)} style={{ marginLeft: '10px' }}>
                                                <DeleteIcon />
                                            </div>
                                        )}
                                    </div>
                                </td>
                                {/* Add input fields for each column */}
                                <td><input type="text" className="form-control form-control-sm" name="TAN_No" placeholder="Enter Organization Branch" value={row.TAN_No} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="SectionCode" placeholder="Enter Bank Name" value={row.SectionCode} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="CertificateNo" placeholder="Enter Bank Branch" value={row.CertificateNo} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="Rate" placeholder="Enter Account Number" value={row.Rate} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="ExemptionLimit" placeholder="Enter Swift Code" value={row.ExemptionLimit} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td> <Select
                                    className='custom-select'
                                    options={CurrOpt}
                                /></td>
                                <td><input type="text" className="form-control form-control-sm" name="ValidForm" placeholder="Enter MICR No" value={row.ValidForm} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="TAN_No" placeholder="Enter Organization Branch" value={row.TAN_No} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="SectionCode" placeholder="Enter Bank Name" value={row.SectionCode} onChange={(event) => handleInputChange(index, event)} /></td>
                                <td><input type="text" className="form-control form-control-sm" name="CertificateNo" placeholder="Enter Bank Branch" value={row.CertificateNo} onChange={(event) => handleInputChange(index, event)} /></td>

                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Export